import {  useState } from "react";
import {
  FaWifi,
  FaRotateRight,
  FaCloudArrowDown,
} from "react-icons/fa6";


const NoNetwork = () => {
  const [isOnline, setIsOnline] = useState(
    typeof navigator !== "undefined" ? navigator.onLine : true
  );
  const [checking, setChecking] = useState(false);

  const handleRetry = async () => {
    setChecking(true);

    // Give the browser a moment to update its network state.
    await new Promise((resolve) => setTimeout(resolve, 800));

    setIsOnline(navigator.onLine);
    setChecking(false);


  };

  return (
    <main className="min-h-screen bg-slate-50 flex items-center justify-center px-6 py-10">
      <div className="w-full max-w-lg text-center">

        {/* Logo */}
        {/* <div className="mb-10 flex items-center justify-center">
          <img
            src={Logo}
            alt="Chrome Architecture Limited"
            className="h-16 w-auto object-contain"
          />
        </div> */}

        {/* Illustration */}
        <div className="relative mx-auto mb-8 flex h-40 w-40 items-center justify-center">

          {/* Decorative circles */}
          <div className="absolute inset-0 rounded-full border border-blue-100" />

          <div className="absolute inset-4 rounded-full border border-blue-100" />

          <div className="absolute inset-8 rounded-full bg-blue-50" />

          {/* Icon */}
          <div className="relative flex h-20 w-20 items-center justify-center rounded-2xl bg-white text-blue-600 shadow-xl shadow-slate-200/80">
            {FaWifi({ className: "text-3xl" })}

            <div className="absolute -right-2 -top-2 flex h-7 w-7 items-center justify-center rounded-full border-4 border-slate-50 bg-red-500">
              <span className="h-2 w-2 rounded-full bg-white" />
            </div>
          </div>
        </div>

        {/* Content */}
        <div>
          <div className="mb-3 inline-flex items-center gap-2 rounded-full bg-blue-50 px-3 py-1.5 text-xs font-semibold text-blue-700">
            <span
              className="h-1.5 w-1.5 rounded-full bg-red-500"
            />

            {"No internet connection"}
          </div>

          <h1 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
            You’re offline
          </h1>

          <p className="mx-auto mt-4 max-w-md text-sm leading-6 text-slate-500 sm:text-base">
            We can’t connect you right now. Please check
            your internet connection and try again.
          </p>
        </div>

        {/* Status Card */}
        <div className="mt-8 rounded-2xl border border-slate-200 bg-white p-4 text-left shadow-sm">
          <div className="flex items-start gap-3">
            <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-blue-50 text-blue-600">
              {FaCloudArrowDown({ className: "text-sm" })}
            </div>

            <div>
              <p className="text-sm font-semibold text-slate-800">
                Your session is safe
              </p>

              <p className="mt-1 text-xs leading-5 text-slate-500">
                Once your connection is restored, you can
                continue using Chrome Architecture Limited Software.
              </p>
            </div>
          </div>
        </div>

        {/* Actions */}
        <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:justify-center">

          <button
            type="button"
            onClick={handleRetry}
            disabled={checking}
            className="inline-flex h-11 items-center justify-center gap-2 rounded-xl bg-blue-600 px-6 text-sm font-semibold text-white shadow-lg shadow-blue-600/20 transition-all hover:bg-blue-700 hover:shadow-blue-600/30 disabled:cursor-not-allowed disabled:opacity-60"
          >
            {FaRotateRight({
              className: `text-xs ${checking ? "animate-spin" : ""}`
            })}

            {checking ? "Checking..." : "Try Again"}
          </button>

{/* 
          <button
            type="button"
            // onClick={onBack}
            className="inline-flex h-11 items-center justify-center gap-2 rounded-xl border border-slate-200 bg-white px-6 text-sm font-semibold text-slate-700 transition-all hover:border-slate-300 hover:bg-slate-50"
          >
            {FaArrowLeft({ className: "text-xs" })}
            Go Back
          </button> */}

        </div>

        {/* Footer */}
      {/* <p className="mt-10 text-xs text-slate-400">
    Chrome Architecture Limited
    <span className="mx-2">•</span>
    Business Software Solutions
</p> */}
      </div>
    </main>
  );
};

export default NoNetwork;